import { useEffect, useState } from 'react';
import { useContent } from '../hooks/useContent';
import { DIR_CARD_IMAGES } from '../data/managementImages';
import imgUtelbaeva from '../assets/pravlenie/utelbaeva.jpg';
import imgErekesheva from '../assets/pravlenie/erekesheva.png';
import imgNadirbekov from '../assets/pravlenie/nadirbekov.jpg';
import './Management.css';

const APP_PUBLIC = process.env.PUBLIC_URL || '';

function encodePublicPath(path) {
  return path
    .split('/')
    .map((segment) => (segment === '' ? '' : encodeURIComponent(segment)))
    .join('/');
}

function publicAssetSrc(path) {
  if (!path) return '';
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${APP_PUBLIC}${encodePublicPath(normalized)}`;
}

const PRAVLENIE_IMAGES = [imgUtelbaeva, imgErekesheva, imgNadirbekov];

export default function Management() {
  const { DIR_CARDS, ui } = useContent();
  const mgmt = ui.management;
  const BOARD = mgmt.board;
  const PRAVLENIE = mgmt.pravlenie.map((p, i) => ({ ...p, image: PRAVLENIE_IMAGES[i] }));
  const tabs = [
    { k: 'board', l: mgmt.tabs.board },
    { k: 'pravlenie', l: mgmt.tabs.pravlenie },
    { k: 'directors', l: mgmt.tabs.directors },
    { k: 'structure', l: mgmt.tabs.structure },
  ];

  const [activeTab, setActiveTab] = useState('pravlenie');
  const [dirIdx, setDirIdx] = useState(0);
  const VISIBLE = 4;

  useEffect(() => {
    const hashToTab = {
      '#management': 'pravlenie',
      '#board': 'board',
      '#directors': 'directors',
      
      '#structure': 'structure',
    };

    const applyTabByHash = () => {
      const targetTab = hashToTab[window.location.hash];
      if (targetTab) setActiveTab(targetTab);
    };

    applyTabByHash();
    window.addEventListener('hashchange', applyTabByHash);
    return () => window.removeEventListener('hashchange', applyTabByHash);
  }, []);

  const prevDir = () => setDirIdx(i => Math.max(0, i - 1));
  const nextDir = () => setDirIdx(i => Math.min(DIR_CARDS.length - VISIBLE, i + 1));

  return (
    <section style={{ background: 'var(--white)' }}>
  {/* якоря для навигации */}
  <span id="management" style={{ position: 'absolute', marginTop: '-80px' }} />
  <span id="board" style={{ position: 'absolute', marginTop: '-80px' }} />
  <span id="directors" style={{ position: 'absolute', marginTop: '-80px' }} />

  <span id="structure" style={{ position: 'absolute', marginTop: '-80px' }} />
      <div className="section">
        <div className="section-label">{mgmt.label}</div>
        <h2 className="section-title">{mgmt.title} <em>{mgmt.titleEm}</em></h2>

        {/* TABS */}
        <div className="mgmt-tabs">
          {tabs.map(t => (
            <button
              key={t.k}
              
              className={`mgmt-tab ${activeTab === t.k ? 'active' : ''}`}
              onClick={() => setActiveTab(t.k)}
            >
              {t.l}
            </button>
          ))}
        </div>

        {/* PRAVLENIE */}
        {activeTab === 'pravlenie' && (
          <div className="mgmt-section" key="pravlenie">
            <div className="mgmt-chair-wrap">
              <PersonCard person={PRAVLENIE[0]} size="large" chairBadge={mgmt.chairBadge} />
            </div>
            <div className="mgmt-deputies">
              {PRAVLENIE.slice(1).map((p, i) => (
                <PersonCard key={i} person={p} size="medium" />
              ))}
            </div>
            <div className="mgmt-link-row">
              
            </div>
          </div>
        )}

        {/* BOARD */}
        {activeTab === 'board' && (
          <div className="mgmt-section" key="board">
            <div className="mgmt-board-grid">
              {BOARD.map((p, i) => (
                <PersonCard key={i} person={p} size="medium" showTag />
              ))}
            </div>
            <div className="mgmt-link-row">
              
            </div>
          </div>
        )}

        {/* DIRECTORS CAROUSEL */}
        {activeTab === 'directors' && (
          <div className="mgmt-section" key="directors">
            <div className="dirs-carousel-outer">
              <button className="dirs-nav" onClick={prevDir} disabled={dirIdx === 0} aria-label={ui.common.back}>
                <ChevL />
              </button>
              <div className="dirs-carousel-viewport">
                <div
                  className="dirs-carousel-track"
                  style={{ transform: `translateX(-${dirIdx * (204 + 24)}px)` }}
                >
                  {DIR_CARDS.map((d, i) => (
                    <div key={i} className="dir-card">
                      <div className="dir-avatar">
                        <DirectorAvatar image={DIR_CARD_IMAGES[i]} initials={d.initials} name={d.name} />
                      </div>
                      <div className="dir-name">{d.name}</div>
                      <div className="dir-dept">{d.dept}</div>
                    </div>
                  ))}
                </div>
              </div>
              <button className="dirs-nav" onClick={nextDir} disabled={dirIdx >= DIR_CARDS.length - VISIBLE} aria-label={ui.common.forward}>
                <ChevR />
              </button>
            </div>
          </div>
        )}

     

        {/* ORGANIZATIONAL STRUCTURE */}
        {activeTab === 'structure' && (
          <div className="mgmt-section" key="structure">
            <div className="structure-wrap">
              <button
                type="button"
                className="structure-card"
                data-preview-url="/org-structure.png"
                data-preview-title={mgmt.structureCaption}
                aria-label={mgmt.structureAria}
              >
                <img
                  src="/org-structure.png"
                  alt={mgmt.structureCaption}
                  className="structure-img"
                  loading="lazy"
                />
                <div className="structure-hint">
                  {mgmt.structureHint}
                  <span className="structure-hint-icon">↗</span>
                </div>
              </button>
              <div className="structure-actions">
                <a
                  className="btn-link"
                  href="/org-structure.png"
                  target="_blank"
                  rel="noreferrer"
                >
                  {mgmt.structureOpen}
                  <ExtIcon />
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

function DirectorAvatar({ image, initials, name }) {
  const [failed, setFailed] = useState(false);
  const src = resolveAvatarSrc(image);
  if (!image || failed || !src) {
    return <span>{initials}</span>;
  }
  return (
    <img
      src={src}
      alt={name}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}

function resolveAvatarSrc(image) {
  if (image == null || image === '') return '';
  if (typeof image !== 'string') return image;
  if (image.startsWith('http') || image.startsWith('data:')) return image;
  if (image.startsWith('/static/')) return image;
  return publicAssetSrc(image);
}

function PersonCard({ person, size, showTag, chairBadge }) {
  const sz = { large: 200, medium: 152 }[size] || 120;
  return (
    <div className={`person-card person-card--${size}`}>
      <div className="person-avatar" style={{ width: sz, height: sz }}>
        <DirectorAvatar
          image={person.image}
          initials={person.initials}
          name={person.role || person.name}
        />
      </div>
      {showTag && <div className="person-tag">{person.tag}</div>}
      <div className="person-name">{person.name}</div>
      <div className="person-role">{person.role}</div>
      {person.isChair && chairBadge && <span className="person-badge">{chairBadge}</span>}
    </div>
  );
}

function ChevL() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>; }
function ChevR() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 6l6 6-6 6"/></svg>; }
function ExtIcon() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>; }